import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["supplier", "transaction"]
  static values = { url: String, prompt: String }

  connect() {
    this.selectedTransactionId = this.transactionTarget.value
    this.fallbackOptions = Array.from(
      this.transactionTarget.options,
      (option) => option.cloneNode(true)
    )
    this.load()
  }

  disconnect() {
    this.abortController?.abort()
  }

  supplierChanged() {
    this.selectedTransactionId = null
    this.load()
  }

  async load() {
    const supplierId = this.supplierTarget.value
    this.transactionTarget.replaceChildren(this.promptOption())
    this.transactionTarget.disabled = true
    if (!supplierId) return

    this.abortController?.abort()
    this.abortController = new AbortController()
    const url = this.urlValue
      .replace(":customer_id", supplierId)
      .replace("%3Acustomer_id", supplierId)

    try {
      const response = await fetch(url, {
        headers: { Accept: "application/json" },
        signal: this.abortController.signal
      })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      const payload = await response.json()
      const options = [this.promptOption()]
      payload.business_transactions.forEach((transaction) => {
        const option = document.createElement("option")
        option.value = transaction.id
        option.textContent = transaction.name
        option.selected = String(transaction.id) === String(this.selectedTransactionId)
        options.push(option)
      })

      this.transactionTarget.replaceChildren(...options)
      this.transactionTarget.disabled = false
      if (!this.transactionTarget.value && payload.business_transactions.length === 1) {
        this.transactionTarget.value = payload.business_transactions[0].id
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        if (this.selectedTransactionId) {
          const options = this.fallbackOptions.map((option) => option.cloneNode(true))
          this.transactionTarget.replaceChildren(...options)
        }
        this.transactionTarget.disabled = false
      }
    }
  }

  promptOption() {
    const option = document.createElement("option")
    option.value = ""
    option.textContent = this.promptValue
    return option
  }
}
